var _circle, _circle2, _circle3, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#F8696E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_88684)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M103.811 78.0668C103.418 78.0668 103.154 78.0668 102.893 78.0668C97.2017 78.0668 91.5107 78.0696 85.8196 78.0586C85.3689 78.0586 84.8963 78.023 84.4731 77.8834C83.3162 77.4945 82.6897 76.35 82.882 75.1095C83.0634 73.9485 84.0884 73.0668 85.3497 73.0614C89.3727 73.0477 93.3958 73.0531 97.4188 73.0531C99.5155 73.0531 101.612 73.0531 103.907 73.0531C102.939 72.0865 102.057 71.276 101.263 70.3888C100.9 69.9836 100.582 69.4524 100.466 68.9294C100.222 67.8313 100.785 66.8072 101.75 66.3034C102.684 65.8133 103.786 65.9557 104.618 66.6813C104.723 66.7717 104.819 66.8702 104.915 66.9661C107.13 69.1731 109.348 71.3746 111.557 73.5871C112.824 74.8549 112.818 76.2678 111.549 77.5356C109.274 79.8083 106.998 82.0865 104.709 84.3456C103.868 85.1753 102.736 85.3313 101.744 84.8138C100.785 84.3127 100.222 83.2804 100.466 82.1824C100.584 81.6594 100.903 81.1309 101.263 80.7229C102 79.885 102.827 79.1293 103.618 78.3352C103.651 78.3023 103.673 78.2612 103.813 78.0696L103.811 78.0668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4006 65.7831C80.4116 62.5082 79.0458 60.1287 76.1962 58.5104C71.5356 55.8625 54.0256 45.7119 54.0256 45.7119C51.1842 46.9633 49.5079 49.6413 49.5079 52.9655C49.5024 64.0115 49.5079 75.0602 49.5079 86.1062C49.5079 90.1615 49.4914 94.2141 49.5134 98.2694C49.5299 101.243 50.8269 103.513 53.4183 105.025C53.8524 105.277 54.2866 105.526 54.7235 105.778C59.4088 108.475 64.0969 111.169 68.7822 113.869C70.8321 115.049 72.9838 115.353 75.2344 114.556C78.4111 113.431 80.3291 110.745 80.3868 107.385C80.4061 106.232 80.3731 76.4896 80.4033 65.7831H80.4006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.1521 50.0327C71.8442 50.0327 81.5336 50.0299 91.2257 50.0327C92.9816 50.0327 94.0286 51.0924 94.0314 52.853C94.0369 55.95 94.0259 59.0496 94.0369 62.1466C94.0424 63.6444 95.1058 64.7643 96.5155 64.7917C97.9335 64.8218 99.0684 63.68 99.0766 62.1548C99.0931 58.9894 99.1206 55.8213 99.0711 52.6559C99.0052 48.272 95.6664 45.0135 91.2642 45.008C79.926 44.9943 68.5906 44.9943 57.2525 45.0217C56.4226 45.0217 55.5543 45.1531 54.7656 45.4105C54.4935 45.4982 54.2352 45.6022 53.9824 45.7145L61.5366 50.0737C61.8499 50.0518 62.001 50.0354 62.1521 50.0354V50.0327Z",
    fill: "url(#paint0_linear_4655_88684)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M81.2035 103.844C84.6549 103.839 88.1091 103.918 91.5578 103.806C95.9106 103.663 98.9993 100.402 99.0406 96.0594C99.068 93.3486 99.0543 90.6378 99.0351 87.9269C99.0323 87.5271 98.9471 87.1054 98.796 86.7358C98.3426 85.6405 97.1774 85.0737 95.9821 85.3146C94.8389 85.5447 94.0118 86.5386 94.0035 87.7736C93.987 90.4625 93.998 93.1487 93.998 95.8376C93.998 97.7982 92.9648 98.836 91.0055 98.8387C87.6914 98.8415 84.3774 98.8387 81.0633 98.8387C80.8572 98.8387 80.6511 98.8223 80.3818 98.8086V103.841C80.7061 103.841 80.9589 103.841 81.209 103.841L81.2035 103.844Z",
    fill: "url(#paint1_linear_4655_88684)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4655_88684",
    x1: 61.0005,
    y1: 49.4998,
    x2: 99.5005,
    y2: 49.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_88684",
    x1: 80.5001,
    y1: 103.866,
    x2: 99.5001,
    y2: 103.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_88684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 70,
    fill: "white",
    transform: "translate(49.5 45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSignOut);
export default __webpack_public_path__ + "static/media/img_sign_out.f80d36ef3c3395183e9547656a88d513.svg";
export { ForwardRef as ReactComponent };